import { render, staticRenderFns } from "./suggestion-sort.vue?vue&type=template&id=5f5fba70&scoped=true"
import script from "./suggestion-sort.vue?vue&type=script&lang=js"
export * from "./suggestion-sort.vue?vue&type=script&lang=js"
import style0 from "./suggestion-sort.vue?vue&type=style&index=0&id=5f5fba70&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5fba70",
  null
  
)

export default component.exports